import { render, staticRenderFns } from "./landingpage.vue?vue&type=template&id=7c6edbda"
import script from "./landingpage.vue?vue&type=script&lang=js"
export * from "./landingpage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\vescort-platform-pc-website\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('7c6edbda')) {
      api.createRecord('7c6edbda', component.options)
    } else {
      api.reload('7c6edbda', component.options)
    }
    module.hot.accept("./landingpage.vue?vue&type=template&id=7c6edbda", function () {
      api.rerender('7c6edbda', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/landingpage/landingpage.vue"
export default component.exports